import { Component, computed, inject, input, LOCALE_ID } from '@angular/core';
import { TruckIcon } from '../../../../../../shared/ui/icons/truck-icon/truck-icon';
import { SubmitButton } from '../../../../../../shared/ui/Buttons/submit-button/submit-button';

@Component({
  selector: 'app-order-summary-card',
  imports: [TruckIcon, SubmitButton],
  templateUrl: './order-summary-card.html',
  styleUrl: './order-summary-card.scss',
})
export class OrderSummaryCard {
  private locale = inject(LOCALE_ID);

  isArabic = computed(() => this.locale.startsWith('ar'));

  invoiceNo = input();
  totalQuantity = input();
  totalPharmacyPrice = input<number>();
  totalPeoplePrice = input<number>();
  placedOn = input();
  deliveryMan = input();
  total = input<number>();
  expectedDeliveryDate = input<{
    date: string;
    timeFrom: string;
    timeTo: string;
  }>();
  orderData = input<any>();

  formatExpectedDelivery(): string {
    const delivery = this.expectedDeliveryDate();

    if (!delivery) {
      return '';
    }

    const locale = this.isArabic() ? 'ar-EG' : 'en-US';

    const date = new Date(delivery.date);

    const formattedDate = new Intl.DateTimeFormat(locale, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);

    const formatTime = (time: string) => {
      const [timePart, period] = time.trim().split(' ');
      const [hours, minutes] = timePart.split(':').map(Number);

      const timeDate = new Date();
      timeDate.setHours(
        period?.toUpperCase() === 'PM' ? (hours === 12 ? 12 : hours + 12) : hours === 12 ? 0 : hours,
        minutes,
        0,
        0,
      );

      return new Intl.DateTimeFormat(locale, {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      }).format(timeDate);
    };

    return `${formattedDate}, ${formatTime(delivery.timeFrom)} - ${formatTime(delivery.timeTo)}`;
  }
}
